import React, { useRef, useEffect, useState } from "react";
import { Editor } from "@tinymce/tinymce-react";
import StyleInput from "../../../components/Button/Input";
import StyleSelect from "../../../components/Button/AutoComplete";
import formtrans from "../../../translate/forms";
import tabletrans from "../../../translate/tables";
import { Autocomplete } from "@mui/material";
import { TextField } from "@mui/material";
import env from "../../../env";
function StoryDetails(props) {
  const editorRef = useRef(null);
  const token = props.token;
  const content = props.content;

  return (
    <div className="serviceItem">
      <StyleInput
        title={"عنوان"}
        direction={props.direction}
        defaultValue={content ? content.title : ""}
        class={"formInput"}
        action={(e) =>
          props.setSliderChange((prevState) => ({
            ...prevState,
            title: e,
          }))
        }
      />
      <StyleInput
        title={"عنوان انگلیسی"}
        direction={props.direction}
        defaultValue={content ? content.enTitle : ""}
        class={"formInput"}
        action={(e) =>
          props.setSliderChange((prevState) => ({
            ...prevState,
            enTitle: e,
          }))
        }
      />

      <div className="content">
        <p>توضیحات</p>
        <Editor
          apiKey="53gd69g53pxoc0d8a4ui3kwzoleqj9o5hpcmgu0wdy9t1s2v"
          onInit={(evt, editor) => (editorRef.current = editor)}
          initialValue={content ? content.description : ""}
          onEditorChange={(e) =>
            props.setSliderChange((prevState) => ({
              ...prevState,
              description: e,
            }))
          }
          init={{
            height: 500,
            menubar: false,
            plugins: [
              "advlist",
              "autolink",
              "lists",
              "link",
              "image",
              "charmap",
              "preview",
              "anchor",
              "searchreplace",
              "visualblocks",
              "code",
              "fullscreen",
              "insertdatetime",
              "media",
              "table",
              "code",
              "help",
              "wordcount",
            ],
            toolbar:
              "undo redo | blocks | " +
              "bold italic forecolor | alignleft aligncenter " +
              "alignright alignjustify | bullist numlist outdent indent | " +
              "removeformat | help",
            content_style:
              "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
          }}
        />
      </div>
    </div>
  );
}
export default StoryDetails;
